import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck, Facebook, Instagram, Youtube } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import heroCutout from "../../assets/images/whatwedo/celebrityMarketing/celebrityMarketing.png";

// Same layout as the Events & Experiences hero (.ee-hero-* in eventsExperiences.css).
const POINTS = [
  "Film, music and sports stars matched to your brand",
  "Contracts, approvals and appearances handled for you",
  "From strategy to on-ground execution",
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61571039155522" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/hkiofficial" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@Hki_music" },
];

const CelebHero = () => (
  <section className="ee-hero">
    {/* Themed backdrop, colour blob, outlined word and celebrity cutout. */}
    <div className="ee-hero-visual" aria-hidden="true">
      <div className="ee-hero-bg" />
      <div className="ee-hero-blob" />
      <span className="ee-hero-word">Celebrity</span>
      <img className="ee-hero-cutout" src={heroCutout} alt="" />
    </div>

    <div className="ee-hero-card" data-aos="fade-right" data-aos-once="true">
      <span className="ee-hero-card-kicker">Celebrity Marketing</span>
      <h1 className="ee-hero-card-title">
        The right celebrity <span>for your brand story.</span>
      </h1>
      <p className="ee-hero-card-lead">The right face, every deal managed, the whole collaboration delivered.</p>
      <p className="ee-hero-card-desc">
        We connect brands and hosts with the right celebrities for launches, events and campaigns.
      </p>
      <ul className="ee-checks">
        {POINTS.map((point) => (
          <li key={point}>
            <CircleCheck size={16} /> {point}
          </li>
        ))}
      </ul>
      <Link to={APP_ROUTES.CONTACT_US} className="ee-btn">
        Start a Campaign <ArrowRight size={16} />
      </Link>
    </div>

    <div className="ee-hero-bar">
      <div className="ee-hero-socials">
        {SOCIALS.map(({ icon: Icon, label, href }) => (
          <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
            <Icon size={16} />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default CelebHero;
